import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

import type { AppSettingsAppGroupIdQuietHoursRulesDataResult } from "./types";

const isWorkspaceQuietHoursRule = objectOf({
  id: string,
  channel: string,
  quiet_time_start: string,
  quiet_time_end: string,
});

export const isAppSettingsAppGroupIdQuietHoursRulesDataResult =
  objectOf<AppSettingsAppGroupIdQuietHoursRulesDataResult>({
    id: string,
    unread_changelog_count: maybe(number, true),
    rules: arrayOf(isWorkspaceQuietHoursRule),
  });
